import { PublicApiClient } from '@japan-culture-and-technology/calchez-utils/src/clients/publicApiClient';

import type { UseRuntimeConfig } from '@/injectionKeys';
import { useRuntimeConfigKey } from '@/injectionKeys';

/**
 * NOTE: Nuxt3 化するタイミングでは axios を利用
 * axios -> useFetch に差し替えるタイミングで内部ロジックを再度修正する
 */
export const useFetchToCloudFunctionApi = () => {
  const useRuntimeConfig = inject(useRuntimeConfigKey) as UseRuntimeConfig;
  const runtimeConfig = useRuntimeConfig();

  const cloudFunctionApiClient = PublicApiClient.create(runtimeConfig.public.CLOUD_FUNCTION_BASE_URL as string, () => alert);

  return { cloudFunctionApiClient };
};
